import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'

/**
 * @return {null}
 */
function AuthPage({...props}) {

  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search)
      localStorage.setItem('jwt-token', params.get('token'))
      let redirectPath = params.get('redirectPath')
      history.push(redirectPath ? redirectPath : '/')
    }
  }, [location.search])

  return null
}

export default AuthPage
